import { useSettings } from '../hooks/useSettings';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { TenantSelector } from './TenantSelector';
import { TooltipHelp } from './TooltipHelp';

interface HeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  tooltipId?: string;
}

export function Header({ title, subtitle, actions, tooltipId }: HeaderProps) {
  const { settings } = useSettings();
  const { user, isUrlLogin } = useAuth();
  const { theme } = useTheme();

  const getUserRoleText = (role: string) => {
    switch (role) {
      case 'ADMIN':
        return 'Administrador';
      case 'USER':
        return 'Usuário';
      default:
        return 'Usuário';
    }
  };

  return (
    <header className="border-b px-6 py-4 transition-colors" style={{ 
      backgroundColor: isUrlLogin ? '#1E1E1F' : 'var(--bg-card)',
      borderColor: isUrlLogin ? 'rgba(255, 255, 255, 0.1)' : 'var(--border-color)'
    }}>
      <div className="flex items-center justify-between">
        {/* Título e Subtítulo */}
        <div className="flex items-center space-x-4">
          {/* Logo da empresa no header */}
          <div className="flex items-center space-x-3">
            {!isUrlLogin && (
              <img
                src={settings?.logoUrl || (theme === 'dark' ? '/assets/default-logo-dark.png' : '/assets/default-logo.png')}
                alt={settings?.companyName || 'Broadcast - Konverte Digital'}
                className="h-8 w-auto object-contain logo-theme-adaptive"
                style={{
                  filter: theme === 'light' ? 'brightness(0) saturate(100%)' : 'none',
                  opacity: theme === 'light' ? 0.8 : 1
                }}
              />
            )}
            <div className={!isUrlLogin ? "border-l pl-3" : ""} style={{ borderColor: isUrlLogin ? 'rgba(255, 255, 255, 0.2)' : 'var(--border-color)' }}>
              <h1 className="text-3xl font-bold flex items-center gap-2" style={{ color: isUrlLogin ? 'white' : 'var(--text-primary)' }}>
                <span>{title}</span>
                {tooltipId && <TooltipHelp id={tooltipId} />}
              </h1>
              {subtitle && (
                <p className="text-sm font-normal" style={{ color: isUrlLogin ? 'rgba(255, 255, 255, 0.8)' : 'var(--text-secondary)' }}>{subtitle}</p>
              )}
            </div>
          </div>
        </div>

        {/* Ações da direita - Only show in normal mode */}
        {!isUrlLogin && (
        <div className="flex items-center space-x-4">
          {/* Tenant Selector */}
          <TenantSelector />

          {/* Avatar do usuário */}
          <div className="flex items-center space-x-3">
              <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--astra-dark-blue)' }}>
              <span className="text-white text-sm font-medium">
                {user?.nome?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            </div>
            <div className="hidden sm:block">
                <p className="text-sm font-normal" style={{ color: 'var(--text-primary)' }}>{user?.nome || 'Usuário'}</p>
                <p className="text-xs font-normal" style={{ color: 'var(--text-secondary)' }}>{getUserRoleText(user?.role || 'USER')}</p>
            </div>
          </div>

          {/* Ações customizadas */}
          {actions && (
              <div className="flex items-center space-x-2 border-l pl-4" style={{ borderColor: 'var(--border-color)' }}>
              {actions}
            </div>
          )}
        </div>
        )}
      </div>
    </header>
  );
}